import './styles/app.css'
import 'vuetify/styles'
import 'vanilla-cookieconsent/dist/cookieconsent.js'
export const app = {
  components: {

  },
  data () {
    return {
      menu: false,
      offsetTop: 0,
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.checkAndUpdateLinks()
      this.checkAndUpdateLinks()
      this.observeDOMChanges()
      this.initCookieConsent()
      window.addEventListener('scroll', this.onScroll);
    })
  },
  methods: {
    onScroll () {
      this.offsetTop = window.scrollY
    },
    initCookieConsent () {
      // @ts-expect-error global window
      const cc = initCookieConsent()
      cc.run({
        gui_options: {
          consent_modal: {
            layout: 'box',
            position: 'bottom right',
            transition: 'slide',
            swap_buttons: false
          },
          settings_modal: {
            layout: 'box',
            transition: 'slide'
          }
        },
        current_lang: window.document.documentElement.lang,
        languages: {
          cs: {
            consent_modal: {
              title: 'Souhlas s používáním cookies',
              description:
                'Tento web a partneři potřebují Váš souhlas s použitím souborů cookies, aby Vám mohli zobrazovat informace v souladu s Vašimi zájmy.<br><br><strong>Chceme, aby pro Vás náš web fungoval jako dobře promazaný stroj.</strong><br><br><button type="button" data-cc="c-settings" class="cc-link">Nastavit podrobně.</button>',
              primary_btn: {
                text: 'Příjmout všechny',
                role: 'accept_all'
              },
              secondary_btn: {
                text: 'Příjmout povinné',
                role: 'accept_necessary'
              }
            },
            settings_modal: {
              title: 'Nastavení cookies',
              save_settings_btn: 'Uložit nastavení',
              accept_all_btn: 'Přimout všechny',
              reject_all_btn: 'Odmítnout všechny',
              close_btn_label: 'Zavřít',
              cookie_table_headers: [
                { col1: 'Název' },
                { col2: 'Doména' },
                { col3: 'Expirace' },
                { col4: 'Popis' }
              ],
              blocks: [
                {
                  title: 'Souhlas s používáním cookies',
                  description:
                    'Zde máte možnost přizpůsobit soubory cookie podle kategorií, v souladu s vlastními preferencemi.'
                },
                {
                  title: 'Nezbytné cookies',
                  description:
                    'Tyto cookies nám pomáhají zajistit základní funkce, jako je zajištění funkčnosti a bezpečného chodu webové stránky, přístup k zabezpečeným částem webové stránky, rychlé načítání webového obsahu, ověření uživatele nebo zaznamenání, zda jste nám udělili souhlas dle tohoto dokumentu, včetně uložení uživatelských preferencí na doméně během relace. Takové cookies jsou nezbytné pro fungování našeho webu, a proto k jejich ukládání a čtení nepotřebujeme váš souhlas.',
                  toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true
                  }
                },
                {
                  title: 'Pokročilé analytické funkce',
                  description:
                    'Na základě vašeho souhlasu používáme cookies, které slouží k vytváření statistik, sledování a analýze chování uživatelů na webové stránce. Data nám pomáhají určit oblíbenost jednotlivých stránek funkcí a slouží jako podklad pro zlepšování webové stránky.',
                  toggle: {
                    value: 'analytics',
                    enabled: false,
                    readonly: false
                  },
                  cookie_table: [
                    {
                      col1: '^_ga',
                      col2: 'google.com',
                      col3: '13 měsíců',
                      col4: 'Google Analytics – sledování stavu a výkonu účtu, shrnutí návštěvnosti, aktivní uživatelé, průzkumník uživatelů, analytika uživatelů, pravděpodobnost konverze, srovnávací zprávy, demografické údaje a zájmy, přehled toku uživatelů, přehledy AdWords; Chcete-li se odhlásit ze sledování službou Google Analytics na všech webových stránkách, navštivte prosím: https://tools.google.com/dlpage/gaoptout. Podrobné informace o Google Analytics a ochraně osobních údajů naleznete na adrese: https://policies.google.com/privacy?hl=cs.',
                      is_regex: true
                    }
                  ]
                },
                {
                  title: 'Více informací',
                  description:
                    'Pro dotazy ohledně zpracování osobních údajů kontaktujte <a class="cc-link" href="mailto:info@lchoil.cz">pověřence na ochranu osobních údajů</a>.'
                }
              ]
            }
          },
        }
      })

    },
    toggleMainMenu () {
      this.menu = !this.menu
    },
    checkAndUpdateLinks () {
      const links = this.$el.querySelectorAll('a')
      links.forEach((link: HTMLAnchorElement) => {
        try {
          const url = new URL(link.href, window.location.href)
          if (url.hostname !== window.location.hostname) {
            link.classList.add('external')
            link.setAttribute('target', '_blank')
          }
        } catch (e) {
          console.error(`Invalid URL: ${link.href}`)
        }
      })
    },
    observeDOMChanges () {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length) {
            this.checkAndUpdateLinks()
          }
        })
      })

      observer.observe(this.$el, { childList: true, subtree: true })
    }
  }
}
